module.exports = __webpack_public_path__ + "static/media/22_A.f2a5718c.png";